import myGoalsGoals from './questions/myGoalsGoals';
import myHairGeneticHairLoss from './questions/myHairGeneticHairLoss';
import myLifestyleDiet from './questions/myLifestyleDiet';
import myLifestyleHormones from './questions/myLifestyleHormones';
import myLifestyleHydration from './questions/myLifestyleHydration';
import myLifestyleOtherHairLossCauses from './questions/myLifestyleOtherHairLossCauses';
import supplementsConsultationWelcome from './questions/supplementsConsultationWelcome';

const supplementsQuestionSet = [
  supplementsConsultationWelcome,
  ...[
    { ...myHairGeneticHairLoss, public: true },
    { ...myLifestyleHormones, public: true },
    { ...myLifestyleDiet, public: true },
    { ...myLifestyleHydration, public: true },
    { ...myLifestyleOtherHairLossCauses, public: true },
    myGoalsGoals,
  ].map(q => ({ ...q, route: q.route.replace('consultation', 'supplements-consultation') })),
];

export default supplementsQuestionSet;
